import { Heading1, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import GenderByRole from './charts/GenderByRole';
import GenderSalaryByExperience from './charts/GenderSalaryByExperience';
import GenderSalaryByRole from './charts/GenderSalaryByRole';
import GenderCalculator from './GenderCalculator';
import GenderHighlight from './GenderHighlight';
import {
  StyledContainer,
  StyledHeader,
  StyledSection,
  StyledSubsection,
  StyledSubsectionHeader
} from './GenderSection.styled';

const GenderSection: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeader>
          <Heading1 as="h2" editorial>
            {t('gender.title')}
          </Heading1>
          <p>{t('gender.desc')}</p>
        </StyledHeader>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('gender.role.title')}</Heading3>
            <p>{t('gender.role.desc')}</p>
          </StyledSubsectionHeader>
          <GenderByRole />
        </StyledSubsection>
      </StyledContainer>
      <GenderHighlight />
      <StyledContainer>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('gender.salary-by-role.title')}</Heading3>
            <p>{t('gender.salary-by-role.desc')}</p>
          </StyledSubsectionHeader>
          <GenderSalaryByRole />
        </StyledSubsection>
        <GenderCalculator />
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('gender.salary-by-experience.title')}</Heading3>
            <p>{t('gender.salary-by-experience.desc')}</p>
          </StyledSubsectionHeader>
          <GenderSalaryByExperience />
        </StyledSubsection>
      </StyledContainer>
    </StyledSection>
  );
};

export default GenderSection;
